import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import isEqual from "lodash/isEqual";
import { api } from "../services/api";
import { stringify } from "../../../../utils/stringify";
import { getSelectedFilters } from "./locationsSelectorReducer";
import { getCommonApiParams } from "../../../../utils/redux-helpers";

export const SET_LOADING = "saga/locations/SET_LOADING";

export const SET_UPDATES_LOADING = "saga/locations/SET_UPDATES_LOADING";

export const FETCH_FILTERS_SUCCESS = "saga/locations/FETCH_FILTERS_SUCCESS";

export const FETCH_CURRENT_USER = "saga/locations/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/locations/FETCH_CURRENT_USER_SUCCESS";

export const UPDATE_FILTERS = "saga/locations/UPDATE_FILTERS";
export const UPDATE_FILTERS_SUCCESS = "saga/locations/UPDATE_FILTERS_SUCCESS";

export const SET_SELECT_STORE = "saga/locations/SET_SELECT_STORE";
export const UPDATE_SELECT_STORE = "saga/locations/UPDATE_SELECT_STORE";

export const ADD_PRESET = "saga/locations/ADD_PRESET";
export const ADD_PRESET_SUCCESS = "saga/locations/ADD_PRESET_SUCCESS";

export const SET_PRESET = "saga/locations/SET_PRESET";

export const UPDATE_CURRENT_PRESET_FILTERS = "saga/locations/UPDATE_CURRENT_PRESET_FILTERS";
export const UPDATE_CURRENT_PRESET_FILTERS_SUCCESS =
  "saga/locations/UPDATE_CURRENT_PRESET_FILTERS_SUCCESS";

export const SAVE_CURRENT_PRESET_FILTERS = "saga/locations/SAVE_CURRENT_PRESET_FILTERS";
export const RESET_CURRENT_PRESET_FILTERS = "saga/locations/RESET_CURRENT_PRESET_FILTERS";
export const EDIT_PRESET = "saga/locations/EDIT_PRESET";
export const EDIT_PRESET_SUCCESS = "saga/locations/EDIT_PRESET_SUCCESS";
export const SET_CURRENT_PRESET = "saga/locations/SET_CURRENT_PRESET";
export const REMOVE_PRESET = "saga/locations/REMOVE_PRESET";
export const REMOVE_PRESET_SUCCESS = "saga/locations/REMOVE_PRESET_SUCCESS";

export const RESET_FILTERS = "saga/locations/RESET_FILTERS";
export const RESET_FILTERS_SUCCESS = "saga/locations/RESET_FILTERS_SUCCESS";

export const RESET = "saga/locations/RESET";
export const RESET_SUCCESS = "saga/locations/RESET_SUCCESS";

export const SET_ERROR = "saga/locations/SET_ERROR";
export const SHOW_RESULTS = "saga/locations/SHOW_RESULTS";

export const SET_DYNAMIC_FILTERS_STATUS = "sagas/locations/SET_DYNAMIC_FILTERS_STATUS";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateFilters: createAction(UPDATE_FILTERS),
  createPreset: createAction(ADD_PRESET),
  setPreset: createAction(SET_PRESET),
  updateCurrentPresetFilters: createAction(UPDATE_CURRENT_PRESET_FILTERS),
  saveCurrentPresetFilters: createAction(SAVE_CURRENT_PRESET_FILTERS),
  resetCurrentPresetFilters: createAction(RESET_CURRENT_PRESET_FILTERS),
  editPreset: createAction(EDIT_PRESET),
  setCurrentPreset: createAction(SET_CURRENT_PRESET),
  removePreset: createAction(REMOVE_PRESET),
  showResults: createAction(SHOW_RESULTS),
  updateSelectStore: createAction(UPDATE_SELECT_STORE),
  resetFilters: createAction(RESET_FILTERS),
  reset: createAction(RESET)
};

export const {
  fetchCurrentUser,
  updateFilters,
  createPreset,
  setPreset,
  setCurrentPreset,
  updateCurrentPresetFilters,
  saveCurrentPresetFilters,
  resetCurrentPresetFilters,
  editPreset,
  removePreset,
  resetFilters,
  reset,
  showResults,
  updateSelectStore
} = actionCreators;

export default function* watchLocations() {
  yield takeLatestSafe(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatestSafe(UPDATE_FILTERS, refetchFilters);
  yield takeLatestSafe(ADD_PRESET, addPreset);
  yield takeLatestSafe(EDIT_PRESET, changePreset);
  yield takeLatestSafe(UPDATE_CURRENT_PRESET_FILTERS, updatePresetFilters);
  yield takeLatestSafe(SAVE_CURRENT_PRESET_FILTERS, savePresetFilters);
  yield takeLatestSafe(REMOVE_PRESET, deletePreset);
  yield takeLatestSafe(SHOW_RESULTS, refreshPage);
  yield takeLatestSafe(RESET_FILTERS, resetAllFilters);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
    }
  };
}

function* resetAllFilters() {
  let organization_id = yield select((state) => state.locations.currentUser.organization_id);
  const { data } = yield call(api.getFilters, { params: { organization_id } });

  yield put({
    type: RESET_FILTERS_SUCCESS,
    payload: data
  });
}

function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });

  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  yield fetchFilters();

  yield put({ type: SET_LOADING, payload: false });
}

function* fetchFilters() {
  let { short_url, organization_id } = yield getCommonApiParams("locations");

  //locations for historical reasons related with mindbody

  const {
    data: { preset_id, preset_type, locations, filteredStores, ...rest }
  } = yield call(api.getFiltersByShortUrl, { params: { short_url } });

  const { data: presets } = yield call(api.getPresets, { params: { organization_id } });

  yield put({
    type: FETCH_FILTERS_SUCCESS,
    payload: {
      filters: rest,
      filteredStores,
      selectedDefaultFilters: getSelectedFilters(rest),
      presets,
      presetId: preset_id,
      presetType: preset_type,
      locations
    }
  });

  yield put({
    type: SET_SELECT_STORE,
    payload: filteredStores
  });
}

const filterParams = {
  statuses: "statuses",
  regions: "region_id",
  divisions: "division_id",
  districts: "district_id",
  stores: "object_id",
  locations: "location_id"
};

function* refetchFilters({ payload: { data: filter, key } }) {
  yield getDynamicFilters({ key, filter, action: UPDATE_FILTERS_SUCCESS });
}

function* getDynamicFilters({ filter, key, action }) {
  if (key === "stores") return;

  let params = yield getParams();

  yield put({ type: SET_DYNAMIC_FILTERS_STATUS, payload: getPendingFilters(key) });

  let filterNames = Object.keys(filterParams);
  let currentFilterIndex = filterNames.findIndex((filterName) => filterName === key);
  let aboveFiltersNames = filterNames.slice(0, currentFilterIndex);

  let selectedFilters = yield select((state) => state.locations.selectedFilters);

  let additionalFilters = aboveFiltersNames.reduce((acc, filterName) => {
    acc[filterParams[filterName]] = stringify(selectedFilters[filterName]);
    return acc;
  }, {});

  const { data } = yield call(api.getFilters, {
    params: { ...params, ...additionalFilters, [filterParams[key]]: stringify(filter) }
  });

  yield put({
    type: action,
    payload: data
  });
  
  yield put({ type: SET_DYNAMIC_FILTERS_STATUS, payload: [] });
}

function* addPreset({ payload }) {
  let isNameDuplicated = yield checkPresetNameDuplication(payload);
  if (isNameDuplicated) return;

  let areOptionsDuplicated = yield checkPresetDuplication({ type: payload.type });
  if (areOptionsDuplicated) return;

  let filters = yield select((state) => state.locations.filters);

  let params = yield getFiltersParams();
  let commonParams = yield getParams();

  let {
    data: { id }
  } = yield call(api.createPreset, {
    name: payload.name,
    preset_type: payload.type,
    ...commonParams,
    ...params
  });

  yield put({
    type: ADD_PRESET_SUCCESS,
    payload: { ...payload, id, filters: filters }
  });
}

function* changePreset({ payload }) {
  let isNameDuplicated = yield checkPresetNameDuplication({
    name: payload.name,
    type: payload.type
  });

  if (isNameDuplicated) return;

  let params = yield getFiltersParams(payload.filters);
  let commonParams = yield getParams();

  yield call(api.editPreset, payload.id, {
    name: payload.name,
    ...commonParams,
    ...params
  });

  yield put({
    type: EDIT_PRESET_SUCCESS,
    payload: payload
  });
}

function* savePresetFilters() {
  let currentPreset = yield select((state) => state.locations.currentPreset);

  let areOptionsDuplicated = yield checkPresetDuplication({
    type: currentPreset.type,
    currentPreset
  });
  if (areOptionsDuplicated) return;

  let params = yield getFiltersParams(currentPreset.filters);
  let commonParams = yield getParams();

  yield call(api.editPreset, currentPreset.id, {
    name: currentPreset.name,
    ...commonParams,
    ...params
  });

  yield put({
    type: EDIT_PRESET_SUCCESS,
    payload: currentPreset
  });
}

function* updatePresetFilters({ payload: { data: filter, key } }) {
  yield getDynamicFilters({ key, filter, action: UPDATE_CURRENT_PRESET_FILTERS_SUCCESS });
}

function* deletePreset() {
  let currentPresetId = yield select((state) => state.locations.currentPreset.id);

  let selectedPreset = yield select((state) => state.locations.selectedPreset);

  yield call(api.removePreset, currentPresetId);

  yield put({
    type: REMOVE_PRESET_SUCCESS,
    payload: { id: currentPresetId }
  });

  yield put({ type: RESET });

  if (selectedPreset && selectedPreset[0].id == currentPresetId) {
    yield resetAllFilters();
  }
}

function* refreshPage({ payload: { name, id } }) {
  yield put({ type: SET_LOADING, payload: true });

  let commonParams = yield getParams();
  let params = yield getFiltersParams();

  let { stores, presetId, presetType } = yield select(
    (state) => state.locations.selectStoreFilters
  );
  let locations = yield select((state) => state.locations.currentUser.allDefaultFilters.locations);

  let object_id = name === "All Stores" ? stringify(stores) : id.toString();

  let { data } = yield call(api.createShortUrl, {
    preset_id: presetId ? presetId.toString() : undefined,
    preset_type: presetType ? presetType : undefined,
    ...commonParams,
    ...params,
    object_id: object_id,
    location_id: filterLocations(name === "All Stores" ? stores : [{ name }], locations),
    filteredStores: stringify(stores)
  });

  var url = window.location.href.split("?")[0] + "?short_url=" + data;
  window.location.replace(url);
}

function filterLocations(stores, locations) {
  let storeNames = stores.map((store) => store.name);
  let filteredLocations = locations.filter((location) => storeNames.includes(location.name));

  return stringify(filteredLocations);
}

function* getPresetByType(type = "regular ") {
  let presets = yield select((state) => state.locations.presets[type]);
  return presets;
}

function* checkPresetNameDuplication({ name, type }) {
  let presets = yield getPresetByType(type);
  let doExists = presets.some((preset) => preset.name === name);

  if (doExists) {
    yield put({ type: SET_ERROR, payload: "preset with this name already exists" });
  }
  return doExists;
}

function* checkPresetDuplication({ type, currentPreset }) {
  let presets = yield getPresetByType(type);

  let possiblePreset = currentPreset
    ? currentPreset.filters
    : yield select((state) => state.locations.filters);

  let doExists = presets.some((preset) => isEqual(preset.filters, possiblePreset));

  if (doExists) {
    yield put({ type: SET_ERROR, payload: "preset with these options already exists" });
  }

  return doExists;
}

function* getParams() {
  let { organization_id } = yield getCommonApiParams("locations");
  return { organization_id };
}

function* getFiltersParams(data) {
  let filters = data ? data : yield select((state) => state.locations.selectedFilters);
  let selectedFilters = getSelectedFilters(filters);
  let params = {};

  for (let key in selectedFilters) {
    params = { ...params, [filterParams[key]]: stringify(selectedFilters[key]) };
  }

  return params;
}

function getPendingFilters(key) {
  let pendingFilters = [];

  switch (key) {
    case "statuses":
      pendingFilters.push("regions", "divisions", "districts", "stores");
      break;
    case "regions":
      pendingFilters.push("divisions", "districts", "stores");
      break;
    case "divisions":
      pendingFilters.push("districts", "stores");
      break;
    case "districts":
      pendingFilters.push("stores");
      break;
    default:
      break;
  }

  return pendingFilters;
}
